<template>
  <div v-frag>
    <CardIeaAppMain>
      <v-col cols="12">
        <!-- Header del Curso -->
        <v-card class="rounded-lg mb-4" elevation="2">
          <v-card-title
            class="curso-header white--text py-3 d-flex align-center"
          >
            <v-btn
              icon
              dark
              class="mr-2"
              @click="$router.push({ name: 'HomeProfesor' })"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <span>Curso: {{ curso.nombre }}</span>
          </v-card-title>
        </v-card>

        <v-row>
          <!-- COLUMNA IZQUIERDA -->
          <v-col cols="12" md="5">
            <!-- Contenido del Curso -->
            <v-card class="rounded-lg mb-4" elevation="2">
              <v-card-title
                class="contenido-header py-2 cursor-pointer"
                @click="showContenido = !showContenido"
              >
                <span class="font-weight-bold text-subtitle-1"
                  >Contenido del Curso</span
                >
                <v-spacer />
                <v-icon>{{
                  showContenido ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-card-title>

              <v-expand-transition>
                <div v-show="showContenido">
                  <v-divider />
                  <div class="pa-3">
                    <div v-if="clasesLoading" class="text-center py-4">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        size="24"
                        width="2"
                      />
                      <div class="text-caption grey--text mt-1">
                        Cargando clases...
                      </div>
                    </div>
                    <div
                      v-else-if="clasesError"
                      class="text-center py-4 error--text"
                    >
                      {{ clasesError }}
                    </div>
                    <div
                      v-else-if="!clasesMateria.length"
                      class="text-center py-4 grey--text"
                    >
                      No hay clases disponibles.
                    </div>
                    <v-card
                      v-for="(clase, index) in clasesMateria"
                      :key="clase.id || index"
                      class="mb-2 rounded-lg"
                      elevation="0"
                      outlined
                    >
                      <v-card-text
                        class="d-flex align-center justify-space-between py-2"
                      >
                        <div class="d-flex align-center">
                          <v-icon
                            v-if="clase.isResumen"
                            small
                            color="red"
                            class="mr-2"
                            >mdi-file-pdf-box</v-icon
                          >
                          <v-icon v-else small color="primary" class="mr-2"
                            >mdi-play-box-outline</v-icon
                          >
                          <span class="text-body-2 font-weight-medium">
                            {{ clase.nombre || `Clase ${index + 1}` }}
                          </span>
                          <v-chip
                            v-if="clase.ediciones && clase.ediciones.length > 0"
                            x-small
                            color="orange"
                            dark
                            label
                            class="ml-2"
                          >
                            Moderación
                          </v-chip>
                        </div>
                        <div>
                          <v-btn
                            outlined
                            x-small
                            color="primary"
                            class="mr-1 rounded-lg"
                            @click="abrirEditorClase(clase)"
                          >
                            Editar
                          </v-btn>
                          <v-btn
                            outlined
                            x-small
                            color="grey"
                            class="rounded-lg"
                            @click="abrirDetalleClase(clase, index)"
                          >
                            Vista Previa
                          </v-btn>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </div>
              </v-expand-transition>
            </v-card>

            <!-- Comunicación del Curso -->
            <v-card class="rounded-lg mb-4" elevation="2">
              <v-card-title class="comunicacion-header white--text py-2">
                Comunicación del Curso
              </v-card-title>
              <v-card-text class="pt-4">
                <div class="d-flex align-center mb-3">
                  <v-icon color="amber darken-2" class="mr-3">mdi-forum</v-icon>
                  <span class="text-body-1 font-weight-bold"
                    >Foro de Dudas</span
                  >
                </div>
                <v-divider class="mb-3" />

                <div v-if="foroLoading" class="text-caption grey--text">
                  Cargando foros...
                </div>
                <div v-else-if="foroError" class="text-caption error--text">
                  {{ foroError }}
                </div>

                <div v-else-if="foroSeleccionado">
                  <div class="d-flex align-center justify-space-between mb-2">
                    <div class="text-body-1 font-weight-bold">
                      {{ foroSeleccionado.title }}
                    </div>
                    <v-btn
                      x-small
                      text
                      color="primary"
                      @click="foroSeleccionado = null"
                      >Volver</v-btn
                    >
                  </div>
                  <div
                    class="text-caption mb-2"
                    :style="{
                      color: foroSeleccionado.category?.color || '#777'
                    }"
                  >
                    {{ foroSeleccionado.category?.name || "Sin sección" }}
                  </div>
                  <div
                    class="text-body-2 mb-3"
                    v-html="foroSeleccionado.content"
                  />

                  <v-textarea
                    v-model="foroComentario"
                    rows="2"
                    outlined
                    dense
                    label="Escribe un comentario"
                    class="mb-2"
                  />
                  <v-btn
                    small
                    color="primary"
                    depressed
                    @click="enviarComentarioForo"
                  >
                    {{ esDocente ? "Comentar como Profesor" : "Comentar" }}
                  </v-btn>

                  <div
                    v-if="foroDetalleLoading"
                    class="text-caption grey--text mt-3"
                  >
                    Cargando mensajes...
                  </div>
                  <div
                    v-else-if="getForoComments(foroSeleccionado).length"
                    class="mt-3"
                  >
                    <div
                      v-for="(comment, idx) in getForoComments(
                        foroSeleccionado
                      )"
                      :key="comment.id || idx"
                      class="mb-2 pa-2 foro-comment-item"
                    >
                      <div
                        class="d-flex align-center justify-space-between mb-1"
                      >
                        <div class="text-caption grey--text">
                          {{ getAutorForo(comment) }}
                        </div>
                        <v-chip
                          v-if="esComentarioDocente(comment)"
                          x-small
                          label
                          color="primary"
                          text-color="white"
                        >
                          Profesor
                        </v-chip>
                      </div>
                      <div class="text-body-2" v-html="comment.comment" />
                    </div>
                  </div>
                  <div v-else class="text-caption grey--text mt-3">
                    Sin comentarios aún.
                  </div>
                </div>

                <div
                  v-else-if="!forosCurso.length"
                  class="text-caption grey--text"
                >
                  No hay temas para este curso.
                </div>

                <div v-else>
                  <div
                    v-for="(foro, index) in forosCurso"
                    :key="foro.id || index"
                    class="mb-2 pa-2 foro-item cursor-pointer"
                    @click="abrirForoDetalle(foro)"
                  >
                    <div class="text-body-2 font-weight-bold">
                      {{ foro.title }}
                    </div>
                    <div
                      class="text-caption"
                      :style="{ color: foro.category?.color || '#777' }"
                    >
                      {{ foro.category?.name || "Sin sección" }}
                    </div>
                    <div class="text-caption grey--text">
                      {{ getForoComments(foro).length }} comentarios -
                      {{ foro.likes || 0 }} likes
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- COLUMNA CENTRAL -->
          <v-col cols="12" md="4">
            <!-- Gestión de Alumnos -->
            <v-card class="rounded-lg mb-4" elevation="2">
              <v-card-title
                class="alumnos-header py-2 cursor-pointer"
                @click="showAlumnos = !showAlumnos"
              >
                <v-icon color="grey darken-2" class="mr-2"
                  >mdi-account-group</v-icon
                >
                <span class="font-weight-bold text-subtitle-1"
                  >Gestión de Alumnos</span
                >
                <v-spacer />
                <v-icon>{{
                  showAlumnos ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-card-title>

              <v-expand-transition>
                <div v-show="showAlumnos">
                  <v-divider />
                  <v-card-text class="pt-3">
                    <div
                      v-for="(alumno, index) in alumnosVisibles"
                      :key="index"
                      class="d-flex align-center mb-3"
                    >
                      <v-avatar size="36" :color="alumno.color" class="mr-3">
                        <span class="white--text text-body-2 font-weight-bold">
                          {{ alumno.iniciales }}
                        </span>
                      </v-avatar>
                      <div class="flex-grow-1">
                        <div class="text-body-2 font-weight-medium">
                          {{ alumno.nombre }}
                        </div>
                        <v-progress-linear
                          :value="alumno.progreso"
                          :color="getColorProgreso(alumno.progreso)"
                          height="8"
                          rounded
                          class="mt-1"
                        />
                      </div>
                      <span class="text-caption grey--text ml-2"
                        >{{ alumno.progreso }}%</span
                      >
                    </div>

                    <div class="text-center mt-2">
                      <v-btn
                        outlined
                        small
                        color="primary"
                        class="rounded-lg"
                        @click="verTodosAlumnos"
                      >
                        Ver Todos
                      </v-btn>
                    </div>
                  </v-card-text>
                </div>
              </v-expand-transition>
            </v-card>

            <v-card class="rounded-lg mb-4" elevation="2">
              <v-card-title class="alumnos-header py-2">
                <v-icon color="grey darken-2" class="mr-2">mdi-book-multiple-outline</v-icon>
                <span class="font-weight-bold text-subtitle-1">Carga de material adicional</span>
              </v-card-title>
              <v-card-text class="pt-3">
                <v-select
                  v-model="claseSeleccionadaId"
                  :items="clasesCurso"
                  item-text="nombre"
                  item-value="id"
                  outlined
                  dense
                  label="Seleccionar clase"
                  class="mb-2"
                  @change="onChangeClaseProfesor"
                />

                <v-select
                  v-model="modoSeccion"
                  :items="tiposSeccion"
                  item-text="label"
                  item-value="value"
                  outlined
                  dense
                  label="Modo de carga"
                  class="mb-4"
                  @change="onCambioModoSeccion"
                />

                <!-- MODO ACTIVIDADES -->
                <template v-if="modoSeccion === 'actividades'">
                  <v-text-field
                    v-model="actividadForm.title"
                    outlined
                    dense
                    label="Titulo de actividad"
                    class="mb-2"
                  />
                  <v-select
                    v-model="actividadForm.tipo"
                    :items="tiposActividad"
                    item-text="label"
                    item-value="value"
                    outlined
                    dense
                    label="Tipo de actividad"
                    class="mb-2"
                  />
                  <v-text-field
                    v-model="actividadForm.fecha_inicio"
                    outlined
                    dense
                    label="Fecha Inicio"
                    type="datetime-local"
                    hide-details
                    class="mb-2"
                  />
                  <v-text-field
                    v-model="actividadForm.fecha_fin"
                    outlined
                    dense
                    label="Fecha Fin"
                    type="datetime-local"
                    hide-details
                    class="mb-3"
                  />
                  <v-textarea
                    v-model="actividadForm.content"
                    outlined
                    dense
                    rows="3"
                    label="Consigna"
                    class="mb-2"
                  />
                  <v-btn
                    color="primary"
                    small
                    depressed
                    :loading="actividadGuardando"
                    @click="crearActividadClase"
                  >
                    Crear actividad
                  </v-btn>

                  <div class="text-subtitle-2 font-weight-bold mt-4 mb-2">
                    Actividades creadas
                  </div>
                  <div v-if="actividadLoading" class="text-caption grey--text">
                    Cargando actividades...
                  </div>
                  <div
                    v-else-if="!actividadesClase.length"
                    class="text-caption grey--text"
                  >
                    Sin actividades.
                  </div>
                  <div v-else>
                    <div
                      v-for="act in actividadesClase"
                      :key="act.id"
                      class="mb-2 pa-2 foro-item"
                    >
                      <div class="text-body-2 font-weight-bold">
                        {{ act.title || act.text }}
                      </div>
                      <div class="text-caption grey--text">
                        {{
                          act.tipo === "subida_pdf"
                            ? "Subida PDF"
                            : "Pregunta/Respuesta"
                        }}
                      </div>
                      <div class="text-caption">{{ act.content }}</div>
                      
                      <div v-if="act.fecha_inicio || act.fecha_fin" class="text-caption blue--text mt-1 d-flex flex-column">
                        <div v-if="act.fecha_inicio">
                          <v-icon x-small color="blue">mdi-calendar-start</v-icon>
                          {{ formatShortDate(act.fecha_inicio) }}
                        </div>
                        <div v-if="act.fecha_fin">
                          <v-icon x-small color="blue">mdi-calendar-end</v-icon>
                          {{ formatShortDate(act.fecha_fin) }}
                        </div>
                      </div>

                      <div class="d-flex justify-end mt-2">
                        <v-btn x-small text color="error" @click="eliminarActividad(act.id)">
                          Eliminar
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- MODO MATERIAL ADICIONAL -->
                <template v-else>
                  <div class="text-subtitle-2 font-weight-bold mb-2">
                    Cargar nuevo material
                  </div>
                  <v-text-field
                    v-model="materialForm.titulo"
                    outlined
                    dense
                    label="Título del material"
                    placeholder="Ej: Video explicativo / Lectura complementaria"
                    class="mb-2"
                  />
                  <v-select
                    v-model="materialForm.tipo"
                    :items="tiposMaterial"
                    item-text="label"
                    item-value="value"
                    outlined
                    dense
                    label="Tipo de material"
                    class="mb-2"
                  />
                  <v-text-field
                    v-model="materialForm.url"
                    outlined
                    dense
                    label="URL del recurso"
                    placeholder="https://..."
                    class="mb-2"
                  />
                  <v-text-field
                    v-model="materialForm.fecha_inicio"
                    outlined
                    dense
                    label="Fecha Inicio"
                    type="datetime-local"
                    hide-details
                    class="mb-2"
                  />
                  <v-text-field
                    v-model="materialForm.fecha_fin"
                    outlined
                    dense
                    label="Fecha Fin"
                    type="datetime-local"
                    hide-details
                    class="mb-2"
                  />
                  
                  <v-btn
                    color="primary"
                    small
                    block
                    depressed
                    :loading="materialGuardando"
                    @click="guardarMaterialAdicional"
                    class="mb-4"
                  >
                    Guardar Material
                  </v-btn>

                  <div class="text-subtitle-2 font-weight-bold mb-2">
                    Materiales de la clase
                  </div>
                  <div v-if="materialLoading" class="text-caption grey--text">
                    Cargando material...
                  </div>
                  <div v-else class="mt-2">
                    <div
                      v-for="mat in materialesClase"
                      :key="mat.id"
                      class="mb-2 pa-2 foro-item"
                    >
                      <div class="d-flex align-center justify-space-between">
                        <div class="text-body-2 font-weight-bold">
                          {{ mat.titulo }}
                        </div>
                        <v-btn
                          x-small
                          color="error"
                          icon
                          @click="eliminarMaterialAdicional(mat.id)"
                        >
                          <v-icon x-small>mdi-delete-outline</v-icon>
                        </v-btn>
                      </div>
                      <div class="text-caption grey--text text-truncate">
                        Tipo: {{ mat.tipo.toUpperCase() }} | {{ mat.url }}
                      </div>
                      <div v-if="mat.fecha_inicio || mat.fecha_fin" class="text-caption blue--text mt-1 d-flex flex-column">
                        <div v-if="mat.fecha_inicio">
                          <v-icon x-small color="blue">mdi-calendar-start</v-icon>
                          {{ formatShortDate(mat.fecha_inicio) }}
                        </div>
                        <div v-if="mat.fecha_fin">
                          <v-icon x-small color="blue">mdi-calendar-end</v-icon>
                          {{ formatShortDate(mat.fecha_fin) }}
                        </div>
                      </div>
                    </div>
                    <div v-if="!materialesClase.length" class="text-caption grey--text">
                      No hay material adicional cargado.
                    </div>
                  </div>
                </template>

                <div class="text-subtitle-2 font-weight-bold mt-4 mb-2">
                  Entregas de alumnos
                </div>
                <div v-if="entregasLoading" class="text-caption grey--text">
                  Cargando entregas...
                </div>
                <div
                  v-else-if="!entregasClase.length"
                  class="text-caption grey--text"
                >
                  Sin entregas aún.
                </div>
                <div v-else>
                  <div
                    v-for="entrega in entregasClase"
                    :key="entrega.id"
                    class="mb-2 pa-2 foro-item"
                  >
                    <div class="d-flex align-center justify-space-between">
                      <div class="text-body-2 font-weight-bold">
                        {{ nombreAlumno(entrega) }}
                      </div>
                      <v-chip
                        x-small
                        :color="entrega.corregido ? 'success' : 'orange'"
                        dark
                      >
                        {{ entrega.corregido ? "Corregido" : "Pendiente" }}
                      </v-chip>
                    </div>
                    <div class="text-caption grey--text">
                      {{ entrega.actividad_titulo }}
                    </div>
                    <div
                      class="text-caption mt-1"
                      v-if="
                        entrega.tipo === 'subida_pdf' && entrega.archivo_url
                      "
                    >
                      <a
                        :href="entrega.archivo_url"
                        target="_blank"
                        rel="noopener"
                        >Ver PDF entregado</a
                      >
                    </div>
                    <div class="text-caption mt-1" v-else>
                      {{ entrega.respuesta_texto || "Sin respuesta textual" }}
                    </div>
                    <v-textarea
                      v-model="entrega.correccion_comentario"
                      dense
                      outlined
                      rows="2"
                      label="Comentario de correccion"
                      class="mt-2"
                    />
                    <div class="d-flex">
                      <v-btn
                        x-small
                        color="success"
                        depressed
                        class="mr-2"
                        @click="marcarEntregaCorregida(entrega, true)"
                      >
                        Marcar corregido
                      </v-btn>
                      <v-btn
                        x-small
                        outlined
                        color="orange"
                        @click="marcarEntregaCorregida(entrega, false)"
                      >
                        Marcar pendiente
                      </v-btn>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- COLUMNA DERECHA -->
          <v-col cols="12" md="3">
            <!-- Calificaciones: vacía hasta tener datos reales (antes era mock) -->
            <v-card class="rounded-lg mb-4" elevation="2">
              <v-card-title class="calificaciones-header white--text py-2">
                Calificaciones
              </v-card-title>
              <v-card-text class="pt-3"></v-card-text>
            </v-card>

            <!-- Recursos del Docente -->
            <v-card class="rounded-lg mb-4" elevation="2">
              <v-card-title class="recursos-header white--text py-2">
                Recursos del Docente
              </v-card-title>
              <v-card-text class="pt-4">
                <v-row>
                  <v-col cols="6">
                    <v-card
                      class="rounded-lg recurso-card pa-3 text-center cursor-pointer"
                      color="#7B1FA2"
                      dark
                      elevation="1"
                      @click="abrirGuias"
                    >
                      <v-icon large class="mb-1">mdi-book-open-variant</v-icon>
                      <div class="text-caption font-weight-medium">
                        Guía de contenido
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="6">
                    <v-card
                      class="rounded-lg recurso-card pa-3 text-center cursor-pointer"
                      color="#9575CD"
                      dark
                      elevation="1"
                      @click="abrirMaterial"
                    >
                      <v-icon large class="mb-1">mdi-file-multiple</v-icon>
                      <div class="text-caption font-weight-medium">
                        Material Adicional
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </CardIeaAppMain>

    <v-dialog v-model="showClasePreviewDialog" max-width="900px">
      <v-card>
        <v-card-title class="d-flex align-center justify-space-between">
          <span
            >Vista Previa:
            {{
              claseMateriaSeleccionada
                ? claseMateriaSeleccionada.nombre
                : "Clase"
            }}</span
          >
          <v-btn icon @click="showClasePreviewDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="claseDetalleLoading" class="text-center py-8">
            <v-progress-circular indeterminate color="primary" />
            <div class="text-caption mt-2">Cargando contenido...</div>
          </div>
          <div
            v-else-if="claseDetalleError"
            class="text-caption error--text text-center py-4"
          >
            {{ claseDetalleError }}
          </div>
          <div v-else>
            <!-- Video Player -->
            <v-responsive
              v-if="currentVideoId"
              class="black rounded-lg mb-4"
              :aspect-ratio="16 / 9"
            >
              <div class="d-flex align-center justify-center fill-height">
                <iframe
                  width="100%"
                  height="100%"
                  :src="`https://www.youtube.com/embed/${currentVideoId}`"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </v-responsive>

            <!-- HTML Content -->
            <div
              v-if="claseDetalleHtml"
              class="clase-detalle-html mt-4"
              v-html="claseDetalleHtml"
            />

            <!-- Resumen PDF -->
            <div
              v-if="
                claseMateriaSeleccionada &&
                  claseMateriaSeleccionada.isResumen &&
                  claseMateriaSeleccionada.path
              "
              class="text-center py-4"
            >
              <v-btn
                color="error"
                depressed
                :href="claseMateriaSeleccionada.path"
                target="_blank"
              >
                <v-icon left>mdi-file-pdf-box</v-icon>
                Ver Resumen Completo (PDF)
              </v-btn>
            </div>

            <div
              v-if="
                !currentVideoId &&
                  !claseDetalleHtml &&
                  !(
                    claseMateriaSeleccionada &&
                    claseMateriaSeleccionada.isResumen
                  )
              "
              class="text-center py-8 grey--text"
            >
              No hay contenido adicional para previsualizar en esta clase.
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="showClasePreviewDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de Edición de Clase (WYSIWYG) -->
    <v-dialog v-model="showEditClaseDialog" max-width="1000px" persistent>
      <v-card>
        <v-card-title class="d-flex align-center justify-space-between">
          <span
            >Editar Detalle:
            {{ claseEditando ? claseEditando.nombre : "" }}</span
          >
          <v-btn icon @click="cerrarEditorClase">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="editLoading" class="text-center py-8">
            <v-progress-circular indeterminate color="primary" />
            <div class="text-caption mt-2">Cargando contenido...</div>
          </div>
          <div v-show="!editLoading">
            <v-alert
              v-if="claseDetallePendiente"
              type="warning"
              outlined
              dense
              class="mb-4"
            >
              <div class="d-flex align-center justify-space-between flex-wrap">
                <span class="text-body-2">
                  Esta clase tiene una <strong>edición pendiente</strong> de aprobación ({{
                    new Date(claseDetallePendiente.created_at).toLocaleDateString()
                  }}).
                </span>
                <v-btn
                  small
                  color="warning"
                  depressed
                  @click="toggleContenidoEditor"
                >
                  {{
                    usarContenidoPendiente
                      ? "Ver Contenido Vigente"
                      : "Ver Contenido Pendiente"
                  }}
                </v-btn>
              </div>
            </v-alert>
            <div id="editor-container" class="mt-2"></div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarEditorClase">Cancelar</v-btn>
          <v-btn
            color="primary"
            depressed
            @click="guardarDetalleClase"
            :loading="editSaving"
          >
            Guardar Cambios
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Guía de Contenido -->
    <v-dialog v-model="guiaDialog" max-width="900px" scrollable>
      <v-card class="guia-dialog-card">
        <v-card-title class="guia-header py-4 px-6 d-flex align-center">
          <v-icon large color="white" class="mr-3">mdi-book-open-page-variant</v-icon>
          <div>
            <div class="text-h5 white--text font-weight-bold">Guía de Contenidos</div>
            <div v-if="guiaContenido" class="text-caption white--text op-80">
              {{ guiaContenido.materia }} | Código: {{ guiaContenido.codigo }}
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="guiaDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-0">
          <div v-if="guiaLoading" class="d-flex flex-column align-center justify-center py-10">
            <v-progress-circular indeterminate color="primary" size="64" class="mb-4"></v-progress-circular>
            <div class="text-subtitle-1 grey--text">Cargando guía educativa...</div>
          </div>

          <div v-else-if="guiaError" class="pa-10 text-center">
            <v-icon color="error" size="64">mdi-alert-circle-outline</v-icon>
            <div class="text-h6 error--text mt-4">{{ guiaError }}</div>
            <v-btn color="primary" depressed class="mt-4" @click="abrirGuias">Reintentar</v-btn>
          </div>

          <div v-else-if="guiaContenido" class="guia-content pa-6">
            <div class="guia-table-wrapper">
              <table class="guia-table">
                <thead>
                  <tr>
                    <th class="text-center" style="width: 100px;">N° CLASE</th>
                    <th class="text-left">CONTENIDOS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="tema in guiaContenido.temas" :key="tema.numero">
                    <td class="text-center font-weight-bold guia-numero-cell">
                      {{ tema.numero }}
                    </td>
                    <td class="guia-tema-cell">
                      <div class="text-subtitle-1 font-weight-bold mb-2 tema-titulo">
                        {{ tema.titulo }}
                      </div>
                      <ul class="guia-subtemas-list">
                        <li v-for="(sub, idx) in tema.subtemas" :key="idx" class="mb-1">
                          {{ sub }}
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="pa-4 guia-footer border-top d-flex justify-space-between">
          <v-btn text color="grey darken-1" @click="guiaDialog = false">
            Cerrar
          </v-btn>
          <v-btn
            v-if="guiaContenido"
            color="error"
            dark
            depressed
            class="px-6"
            @click="descargarGuiaPdf"
          >
            <v-icon left>mdi-file-pdf-box</v-icon>
            Descargar PDF
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "GestionCurso",
  components: {
    CardIeaAppMain
  },
  data() {
    return {
      showContenido: true,
      showAlumnos: true,
      mostrarTodosAlumnos: false,
      forosCurso: [],
      foroLoading: false,
      foroError: "",
      foroSeleccionado: null,
      foroDetalleLoading: false,
      foroComentario: "",
      curso: {
        id: null,
        materiaId: null,
        materiaCodigoId: null,
        nombre: ""
      },
      alumnos: [],
      clasesCurso: [],
      claseSeleccionadaId: null,
      actividadesClase: [],
      entregasClase: [],
      actividadLoading: false,
      entregasLoading: false,
      actividadGuardando: false,
      tiposActividad: [
        { label: "Pregunta y respuesta", value: "pregunta_respuesta" },
        { label: "Subida de trabajo PDF", value: "subida_pdf" }
      ],
      actividadForm: {
        title: "",
        content: "",
        tipo: "pregunta_respuesta",
        fecha_inicio: "",
        fecha_fin: ""
      },
      modoSeccion: "actividades",
      tiposSeccion: [
        { label: "Actividades de las clases", value: "actividades" },
        { label: "Material adicional", value: "material" }
      ],
      materialesClase: [],
      materialForm: {
        titulo: "",
        url: "",
        tipo: "video",
        fecha_inicio: "",
        fecha_fin: ""
      },
      tiposMaterial: [
        { label: "Video", value: "video" },
        { label: "PDF", value: "pdf" },
        { label: "Link/Otro", value: "link" }
      ],
      materialLoading: false,
      materialGuardando: false,
      clasesMateria: [],
      clasesLoading: false,
      clasesError: "",
      selectedClaseIndex: -1,
      selectedVideoIndex: 0,
      currentVideoId: null,
      showClasePreviewDialog: false,
      claseDetalleHtml: "",
      claseDetalleLoading: false,
      claseDetalleError: "",
      // Edición
      showEditClaseDialog: false,
      editorInstance: null,
      claseEditando: null,
      claseDetalleVigente: "",
      claseDetallePendiente: null,
      usarContenidoPendiente: false,
      editLoading: false,
      editSaving: false,
      // Guía de Contenido
      guiaDialog: false,
      guiaLoading: false,
      guiaError: "",
      guiaContenido: null
    };
  },
  computed: {
    user() {
      return this.$store.getters.user || {};
    },
    esDocente() {
      return this.user.tipoUsuario === "profesor";
    },
    nombreProfesor() {
      return (
        this.user.usu_nombre ||
        [this.user.Nombres, this.user.Apellidos].filter(Boolean).join(" ") ||
        "Profesor"
      );
    },
    alumnosVisibles() {
      const lista = this.mostrarTodosAlumnos
        ? this.alumnos
        : this.alumnos.slice(0, 6);
      return lista.map(a => ({
        ...a,
        iniciales: a.nombre
          .split(" ")
          .map(p => p[0])
          .join("")
          .substring(0, 2)
          .toUpperCase()
      }));
    },
    turnoCurso() {
      const nombre = String(this.curso?.nombre || "").trim();
      if (!nombre.includes("-")) return "";
      const partes = nombre.split("-");
      return String(partes[partes.length - 1] || "").trim();
    },
    claseMateriaSeleccionada() {
      if (!this.clasesMateria.length) return null;
      return this.clasesMateria[this.selectedClaseIndex] || null;
    },
    videosClaseSeleccionada() {
      if (!this.claseMateriaSeleccionada) return [];
      return Array.isArray(this.claseMateriaSeleccionada.materia_codigo_link)
        ? this.claseMateriaSeleccionada.materia_codigo_link
        : [];
    }
  },
  methods: {
    calcularProgreso(materiaLog) {
      if (!materiaLog) return 0;

      const posicionClase = Number(materiaLog.posicionClase) + 1;
      const totalClases = Number(materiaLog.totalClases);
      if (
        !totalClases ||
        Number.isNaN(posicionClase) ||
        Number.isNaN(totalClases)
      ) {
        return 0;
      }

      return Math.max(0, Math.min(100, (posicionClase / totalClases) * 100));
    },
    async cargarAlumnos() {
      if (!this.curso.id) return;

      try {
        const res = await this.$API.get({
          url: "profesor/lista-alumnos-v6/" + this.curso.id
        });

        const data = Array.isArray(res.data) ? res.data : [];
        this.alumnos = data.map(alumno => {
          const nombre =
            alumno.fullname ||
            (alumno.alumno
              ? [alumno.alumno.Nombres, alumno.alumno.Apellidos]
                  .filter(Boolean)
                  .join(" ")
              : "Alumno");

          // avance = clases completadas (videos + SCORM + entregas); fallback al último log de video
          const progreso = alumno.avance
            ? Number(alumno.avance.porcentaje) || 0
            : this.calcularProgreso(alumno.materiaLog);

          return {
            nombre,
            progreso: Number(progreso.toFixed(2)),
            color: this.getColorProgreso(progreso)
          };
        });
      } catch (error) {
        this.alumnos = [];
      }
    },
    getColorProgreso(valor) {
      if (valor >= 70) return "#4CAF50";
      if (valor >= 40) return "#FF9800";
      return "#F44336";
    },
    verTodosAlumnos() {
      this.mostrarTodosAlumnos = !this.mostrarTodosAlumnos;
    },
    async cargarForosCurso() {
      const materiaId = Number(
        this.curso.materiaId ||
          this.$route.query.materia_id ||
          this.$route.params.materiaId ||
          this.curso.materiaCodigoId ||
          this.$route.query.materia_codigo_id ||
          this.$route.params.materiaCodigoId ||
          0
      );
      if (!materiaId) return;

      this.foroLoading = true;
      this.foroError = "";
      try {
        const res = await this.$API.get({
          url: `forums-by-catedra/${materiaId}`,
          data: {}
        });
        this.forosCurso = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res)
          ? res
          : [];
      } catch (error) {
        this.foroError = "No se pudieron cargar los foros de este curso.";
        this.forosCurso = [];
      } finally {
        this.foroLoading = false;
      }
    },
    abrirForoDetalle(foro) {
      this.cargarForoDetalle(foro);
    },
    getForoComments(foro) {
      if (!foro) return [];
      if (Array.isArray(foro.comments)) return foro.comments;
      if (Array.isArray(foro.comentarios)) return foro.comentarios;
      if (Array.isArray(foro.forum_comments)) return foro.forum_comments;
      if (Array.isArray(foro.forumComments)) return foro.forumComments;
      return [];
    },
    async cargarForoDetalle(foro) {
      if (!foro?.id) return;
      this.foroDetalleLoading = true;
      this.foroComentario = "";
      try {
        const detalle = await this.$API.get({
          url: `forums/${foro.id}`,
          data: {}
        });

        const foroDetalle = detalle?.data || detalle || foro;
        const commentsNormalizados = this.getForoComments(foroDetalle);
        foroDetalle.comments = commentsNormalizados;
        this.foroSeleccionado = foroDetalle;
      } catch (error) {
        const fallback = { ...foro, comments: this.getForoComments(foro) };
        this.foroSeleccionado = fallback;
      } finally {
        this.foroDetalleLoading = false;
      }
    },
    getAutorForo(item) {
      if (item?.alumno) {
        return `${item.alumno.Nombres || ""} ${item.alumno.Apellidos ||
          ""}`.trim();
      }
      if (item?.docente?.usu_nombre) {
        return item.docente.usu_nombre;
      }
      if (item?.profesor?.usu_nombre) {
        return item.profesor.usu_nombre;
      }
      return "Usuario";
    },
    esComentarioDocente(item) {
      return Boolean(item?.docente || item?.profesor || item?.esProfesor);
    },
    async enviarComentarioForo() {
      if (!this.foroSeleccionado?.id || !this.foroComentario.trim()) return;
      const formData = new FormData();
      formData.append("comment", this.foroComentario.trim());
      formData.append("tagged", "");
      try {
        const comment = await this.$API.post({
          url: `forums-comment/${this.foroSeleccionado.id}`,
          data: formData
        });

        if (!Array.isArray(this.foroSeleccionado.comments)) {
          this.foroSeleccionado.comments = this.getForoComments(
            this.foroSeleccionado
          );
        }

        const comentarioConRol =
          this.esDocente && comment && !comment.docente && !comment.profesor
            ? {
                ...comment,
                profesor: { usu_nombre: this.nombreProfesor },
                esProfesor: true
              }
            : comment;

        this.foroSeleccionado.comments.unshift(comentarioConRol);
        this.foroComentario = "";
      } catch (error) {
        alert("No se pudo enviar el comentario.");
      }
    },
    irForo() {
      this.$router.push({ name: "foro" });
    },
    async abrirGuias() {
      const materiaId = this.curso.materiaCodigoId;
      if (!materiaId) {
        if (this.curso.google_drive) {
          window.open(this.curso.google_drive, "_blank");
        }
        return;
      }

      this.guiaDialog = true;
      this.guiaLoading = true;
      this.guiaError = "";

      try {
        const res = await this.$API.get({
          url: `materia-codigo/contenido-json/${materiaId}`,
          data: {}
        });
        this.guiaContenido = res;
      } catch (error) {
        this.guiaError = "No se pudo cargar la guía de contenidos.";
      } finally {
        this.guiaLoading = false;
      }
    },
    descargarGuiaPdf() {
      const materiaId = this.curso.materiaCodigoId;
      if (!materiaId) return;

      const url = `${this.$API.routeApi}materia-codigo/contenido/${materiaId}?app=PUBLIC`;
      window.open(url, "_blank");
    },
    abrirMaterial() {
      if (this.curso.google_drive) {
        window.open(this.curso.google_drive, "_blank");
      }
    },
    obtenerCodCatedra() {
      // Debe usar el mismo criterio que foros (materia_id) para evitar desfasajes.
      return (
        this.curso.materiaId ||
        this.$route.query.materia_id ||
        this.$route.params.materiaId ||
        this.curso.materiaCodigoId ||
        this.$route.query.materia_codigo_id ||
        this.$route.params.materiaCodigoId
      );
    },
    async cargarClasesCurso() {
      const codCatedra = this.obtenerCodCatedra();
      if (!codCatedra) return;
      this.clasesLoading = true;
      try {
        const res = await this.$API.get({
          url: `materia-codigo/show/${codCatedra}`
        });

        // 1. Normalizacion de clases
        let clasesRaw = Array.isArray(res?.materia_codigo_clase)
          ? res.materia_codigo_clase
          : [];
        clasesRaw = clasesRaw.filter(c => Number(c.view) !== 0);
        clasesRaw.forEach(clase => {
          clase.materia_codigo_link = this.normalizarVideos(
            clase.materia_codigo_link
          );
        });

        // 2. Inyectar resumenes
        const resumenesRaw = Array.isArray(res?.resumen_catedra)
          ? res.resumen_catedra
          : [];
        const clasesConResumenes = [];
        const capitulosRaw = clasesRaw.map(c => Number(c.capitulo || 0));
        const capitulos = [...new Set(capitulosRaw)].sort((a, b) => a - b);

        capitulos.forEach(cap => {
          const clasesCap = clasesRaw.filter(
            c => Number(c.capitulo || 0) === cap
          );
          clasesConResumenes.push(...clasesCap);
          const resCap = resumenesRaw.find(
            r => Number(r.capitulo || 0) === cap
          );
          if (resCap) {
            clasesConResumenes.push({
              ...resCap,
              isResumen: true,
              nombre: `Resumen capítulo ${cap}`,
              capitulo: cap
            });
          }
        });

        this.clasesMateria = clasesConResumenes;

        // 3. Mantener compatibilidad con selector de Actividades
        this.clasesCurso = clasesRaw.map((c, index) => ({
          id: c.id,
          nombre: `Clase ${index + 1}`
        }));

        if (this.clasesCurso.length && !this.claseSeleccionadaId) {
          this.claseSeleccionadaId = this.clasesCurso[0].id;
          await this.onChangeClaseProfesor();
        }
      } catch (error) {
        this.clasesCurso = [];
        this.clasesMateria = [];
        this.clasesError = "Error al cargar las clases.";
      } finally {
        this.clasesLoading = false;
      }
    },
    async onChangeClaseProfesor() {
      if (!this.claseSeleccionadaId) {
        this.actividadesClase = [];
        this.entregasClase = [];
        this.materialesClase = [];
        return;
      }
      if (this.modoSeccion === "actividades") {
        await Promise.all([
          this.cargarActividadesClaseProfesor(),
          this.cargarEntregasClaseProfesor()
        ]);
      } else {
        await this.cargarMaterialesClase();
      }
    },
    async onCambioModoSeccion() {
      if (!this.claseSeleccionadaId) return;
      if (this.modoSeccion === "actividades") {
        await this.cargarActividadesClaseProfesor();
      } else {
        await this.cargarMaterialesClase();
      }
    },
    async cargarMaterialesClase() {
      if (!this.claseSeleccionadaId) return;
      this.materialLoading = true;
      try {
        const res = await this.$API.get({
          url: `profesor/material-clase/${this.claseSeleccionadaId}`
        });
        this.materialesClase = res || [];
      } catch (error) {
        console.error("Error al cargar material:", error);
      } finally {
        this.materialLoading = false;
      }
    },
    async guardarMaterialAdicional() {
      if (!this.claseSeleccionadaId || !this.materialForm.titulo || !this.materialForm.url) {
        alert("Por favor complete título y URL.");
        return;
      }
      this.materialGuardando = true;
      try {
        await this.$API.post({
          url: `profesor/material-clase`,
          data: {
            ...this.materialForm,
            materia_codigo_clase_id: this.claseSeleccionadaId
          }
        });
        // Limpiar form
        this.materialForm = {
          titulo: "",
          url: "",
          tipo: "video",
          fecha_inicio: "",
          fecha_fin: ""
        };
        await this.cargarMaterialesClase();
      } catch (error) {
        alert("Error al guardar material.");
      } finally {
        this.materialGuardando = false;
      }
    },
    async eliminarMaterialAdicional(id) {
      if (!confirm("¿Deseas eliminar este material?")) return;
      try {
        await this.$API.delete({
          url: `profesor/material-clase/${id}`
        });
        await this.cargarMaterialesClase();
      } catch (error) {
        alert("Error al eliminar material.");
      }
    },
    async cargarActividadesClaseProfesor() {
      const codCatedra = this.obtenerCodCatedra();
      if (!codCatedra || !this.claseSeleccionadaId) return;
      this.actividadLoading = true;
      try {
        const res = await this.$API.get({
          url: "materia-codigo-clase/actividades",
          data: {
            cod_catedra: codCatedra,
            materia_codigo_clase_id: this.claseSeleccionadaId,
            turno: this.turnoCurso
          }
        });
        this.actividadesClase = Array.isArray(res?.actividades)
          ? res.actividades
          : [];
      } catch (error) {
        this.actividadesClase = [];
      } finally {
        this.actividadLoading = false;
      }
    },
    async crearActividadClase() {
      if (!this.claseSeleccionadaId || !this.actividadForm.title.trim()) return;
      this.actividadGuardando = true;
      try {
        await this.$API.post({
          url: "profesor/materia-codigo-clase/actividad",
          data: {
            materia_codigo_clase_id: this.claseSeleccionadaId,
            tipo: this.actividadForm.tipo,
            title: this.actividadForm.title.trim(),
            content: this.actividadForm.content.trim(),
            turno: this.turnoCurso,
            view: 1,
            fecha_inicio: this.actividadForm.fecha_inicio || null,
            fecha_fin: this.actividadForm.fecha_fin || null
          }
        });
        this.actividadForm.title = "";
        this.actividadForm.content = "";
        this.actividadForm.tipo = "pregunta_respuesta";
        this.actividadForm.fecha_inicio = "";
        this.actividadForm.fecha_fin = "";
        await this.cargarActividadesClaseProfesor();
      } catch (error) {
        alert("No se pudo crear la actividad.");
      } finally {
        this.actividadGuardando = false;
      }
    },
    async eliminarActividad(id) {
      if (!confirm("¿Está seguro de eliminar esta actividad?")) return;
      try {
        await this.$API.delete({
          url: `profesor/materia-codigo-clase/actividad/${id}`
        });
        await this.cargarActividadesClaseProfesor();
      } catch (error) {
        alert(error?.response?.data?.message || "No se pudo eliminar la actividad.");
      }
    },
    formatShortDate(dateStr) {
      if (!dateStr) return "";
      try {
        const d = new Date(dateStr);
        return d.toLocaleDateString() + " " + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      } catch (e) {
        return dateStr;
      }
    },
    nombreAlumno(entrega) {
      return (
        [entrega?.alumno_nombre, entrega?.alumno_apellido]
          .filter(Boolean)
          .join(" ") || `Alumno ${entrega?.alumno_id || ""}`
      );
    },
    async cargarEntregasClaseProfesor() {
      if (!this.claseSeleccionadaId) return;
      this.entregasLoading = true;
      try {
        const res = await this.$API.get({
          url: "profesor/materia-codigo-clase/entregas",
          data: {
            materia_codigo_clase_id: this.claseSeleccionadaId,
            turno: this.turnoCurso
          }
        });
        this.entregasClase = Array.isArray(res)
          ? res
          : Array.isArray(res?.data)
          ? res.data
          : [];
      } catch (error) {
        this.entregasClase = [];
      } finally {
        this.entregasLoading = false;
      }
    },
    async marcarEntregaCorregida(entrega, corregido) {
      if (!entrega?.id) return;
      try {
        await this.$API.post({
          url: `profesor/materia-codigo-clase/entregas/${entrega.id}/corregir`,
          data: {
            corregido,
            correccion_comentario: entrega.correccion_comentario || ""
          }
        });
        entrega.corregido = !!corregido;
        entrega.status = corregido ? "corregido" : "pendiente";
      } catch (error) {
        alert("No se pudo actualizar el estado de correccion.");
      }
    },
    normalizarVideos(videos) {
      if (!Array.isArray(videos)) return [];
      return videos.map(video => {
        const log = Array.isArray(video.materia_codigo_log)
          ? video.materia_codigo_log[0]
          : null;
        const segundoGuardadoRaw = Number(
          video.videoActualSegundo ||
            (log &&
              (log.videoActualSegundo ||
                log.video_transcurrido ||
                log.videoTranscurrido)) ||
            0
        );
        const segundoGuardado = Number.isFinite(segundoGuardadoRaw)
          ? Math.max(0, segundoGuardadoRaw)
          : 0;
        const porcentajeRaw = Number(video.porcentaje || 0);
        const porcentaje = Number.isFinite(porcentajeRaw)
          ? Math.min(100, Math.max(0, Math.round(porcentajeRaw)))
          : 0;
        return { ...video, videoActualSegundo: segundoGuardado, porcentaje };
      });
    },
    obtenerVideoId(link) {
      if (!link) return null;
      const raw = String(link).trim();
      const match = raw.match(
        /(?:v=|youtu\.be\/|embed\/|shorts\/|live\/)([A-Za-z0-9_-]{11})/i
      );
      return match && match[1] ? match[1] : null;
    },
    async seleccionarClase(index, videoIndex = 0) {
      const clase = this.clasesMateria[index];
      if (!clase) return;
      if (clase.isResumen) {
        if (clase.path) window.open(clase.path, "_blank");
        return;
      }
      this.selectedClaseIndex = index;
      this.selectedVideoIndex = videoIndex;
      this.cargarVideoSeleccionado();
    },
    cargarVideoSeleccionado() {
      let video = this.videosClaseSeleccionada[this.selectedVideoIndex];
      let nextVideoId = this.obtenerVideoId(video?.link);
      if (!video || !nextVideoId) {
        this.currentVideoId = null;
        return;
      }
      this.currentVideoId = nextVideoId;
    },
    async abrirDetalleClase(clase, index) {
      this.selectedClaseIndex = index;
      this.selectedVideoIndex = 0;
      this.cargarVideoSeleccionado();
      this.showClasePreviewDialog = true;
      this.claseDetalleLoading = true;
      this.claseDetalleError = "";
      try {
        const res = await this.$API.get({
          url: `materia-codigo-clase/content/${clase.id}`
        });
        this.claseDetalleHtml = this.normalizarClaseDetalleHtml(
          res?.clase || ""
        );
      } catch (error) {
        this.claseDetalleHtml = "";
        this.claseDetalleError = "No se pudo cargar el detalle de la clase.";
      } finally {
        this.claseDetalleLoading = false;
      }
    },
    normalizarClaseDetalleHtml(html) {
      if (typeof html !== "string") return "";
      return html
        .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
        .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, "")
        .trim();
    },
    // Métodos de Edición
    async abrirEditorClase(clase) {
      if (clase.isResumen) {
        alert("Los resúmenes PDF no se pueden editar desde aquí.");
        return;
      }
      this.claseEditando = clase;
      this.showEditClaseDialog = true;
      this.editLoading = true;
      this.usarContenidoPendiente = false;
      this.claseDetallePendiente = null;
      this.claseDetalleVigente = "";

      try {
        const res = await this.$API.get({
          url: `materia-codigo-clase/content/${clase.id}`
        });
        this.claseDetalleVigente = res?.clase || "";
        this.claseDetallePendiente = res?.pending_edition || null;

        const content = this.claseDetalleVigente;

        // Inicializar editor después de que el DOM esté listo
        await this.$nextTick();
        if (this.editorInstance) {
          await this.editorInstance.destroy();
          this.editorInstance = null;
        }

        if (window.ClassicEditor) {
          const editor = await window.ClassicEditor.create(
            document.querySelector("#editor-container"),
            {
              language: "es",
              toolbar: [
                "heading",
                "|",
                "bold",
                "italic",
                "link",
                "bulletedList",
                "numberedList",
                "|",
                "outdent",
                "indent",
                "|",
                "blockQuote",
                "insertTable",
                "undo",
                "redo"
              ]
            }
          );
          const sanitizedContent = this.normalizarClaseDetalleHtml(content);
          editor.setData(sanitizedContent);
          this.editorInstance = editor;
        } else {
          console.error("CKEditor no está cargado");
        }
      } catch (error) {
        alert("No se pudo cargar el contenido para editar.");
        this.cerrarEditorClase();
      } finally {
        this.editLoading = false;
      }
    },
    cerrarEditorClase() {
      this.showEditClaseDialog = false;
      this.claseEditando = null;
      if (this.editorInstance) {
        this.editorInstance.destroy().then(() => {
          this.editorInstance = null;
        });
      }
    },
    toggleContenidoEditor() {
      if (!this.editorInstance) return;
      this.usarContenidoPendiente = !this.usarContenidoPendiente;
      const content = this.usarContenidoPendiente
        ? this.claseDetallePendiente.contenido_nuevo
        : this.claseDetalleVigente;

      this.editorInstance.setData(this.normalizarClaseDetalleHtml(content));
    },
    async guardarDetalleClase() {
      if (!this.claseEditando || !this.editorInstance) return;
      this.editSaving = true;
      try {
        const content = this.editorInstance.getData();
        const res = await this.$API.post({
          url: `materia-codigo-clase/content/${this.claseEditando.id}`,
          data: {
            content: content
          }
        });
        // Notificar éxito
        if (res && res.status === "pending") {
          if (this.$notification) {
            this.$notification.info({
              title: "Pendiente de Aprobación",
              text: "Los cambios han sido guardados y están pendientes de revisión por un administrador."
            });
          } else {
            alert(
              "Cambios guardados. Están pendientes de aprobación por un administrador."
            );
          }
        } else {
          // Notificar éxito directo
          if (this.$notification) {
            this.$notification.success({
              title: "Guardado",
              text: "El contenido de la clase ha sido actualizado."
            });
          } else {
            alert("Cambios guardados correctamente.");
          }
        }
        this.cerrarEditorClase();
        // Refrescar clases para mostrar el badge de moderación
        this.cargarClasesCurso();
      } catch (error) {
        const message =
          error?.response?.data?.error ||
          error?.data?.error ||
          "Error al guardar los cambios.";
        alert(message);
      } finally {
        this.editSaving = false;
      }
    }
  },
  mounted() {
    const cursoId = this.$route.params.cursoId;
    const cursoNombre = this.$route.params.cursoNombre;
    const materiaId =
      this.$route.query.materia_id || this.$route.params.materiaId;
    const materiaCodigoId =
      this.$route.query.materia_codigo_id || this.$route.params.materiaCodigoId;

    if (cursoNombre) {
      this.curso.nombre = cursoNombre;
      this.curso.id = cursoId;
      this.curso.materiaId = materiaId || null;
      this.curso.materiaCodigoId = materiaCodigoId || null;
    } else {
      this.curso.nombre = "Introducción a la Programación";
      this.curso.id = cursoId || 1;
      this.curso.materiaId = materiaId || null;
      this.curso.materiaCodigoId = materiaCodigoId || null;
    }

    this.cargarAlumnos();
    this.cargarForosCurso();
    this.cargarClasesCurso();
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.curso-header {
  background: linear-gradient(135deg, #1565c0, #0d47a1);
  font-size: 1.1rem;
  font-weight: 600;
}

.contenido-header {
  background-color: #c0392b;
  border-bottom: 2px solid #a93226;
  color: #fff;
}

.modulo-title {
  font-size: 0.95rem;
}

.modulo-nombre {
  color: #c0392b;
}

.comunicacion-header {
  background-color: #27ae60;
  font-size: 1rem;
  font-weight: 600;
}

.alumnos-header {
  background-color: #f5f5f5;
  border-bottom: 2px solid #e0e0e0;
}

.calificaciones-header {
  background-color: #c0392b;
  font-size: 1rem;
  font-weight: 600;
}

.recursos-header {
  background-color: #6a1b9a;
  font-size: 1rem;
  font-weight: 600;
}

.recurso-card {
  min-height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.recurso-card:hover {
  transform: translateY(-2px);
}

.foro-item {
  border: 1px solid #eceff1;
  border-radius: 8px;
}

.foro-comment-item {
  border: 1px solid #eceff1;
  border-radius: 8px;
}

/* Estilos para el contenido HTML de las clases (Portado de MateriaDetalle.vue) */
/* Aplicamos tanto al preview como al área editable del CKEditor */
.clase-detalle-html,
.ck-content {
  max-height: 70vh;
  min-height: 300px;
  overflow: auto;
  padding: 20px !important;
  border: 1px solid #dde3ea !important;
  border-radius: 8px;
  background: #fcfdff !important;
  color: #1f2937 !important;
  font-family: "Segoe UI", Roboto, Arial, sans-serif !important;
  font-size: 1rem !important;
  line-height: 1.7 !important;
}

.clase-detalle-html ::v-deep *,
.ck-content * {
  font-family: inherit !important;
  line-height: inherit;
  box-sizing: border-box;
}

.clase-detalle-html ::v-deep h1,
.ck-content h1,
.clase-detalle-html ::v-deep h2,
.ck-content h2,
.clase-detalle-html ::v-deep h3,
.ck-content h3,
.clase-detalle-html ::v-deep h4,
.ck-content h4,
.clase-detalle-html ::v-deep h5,
.ck-content h5,
.clase-detalle-html ::v-deep h6,
.ck-content h6 {
  color: #111827 !important;
  font-weight: 700 !important;
  line-height: 1.35;
  margin: 1.1em 0 0.6em;
}

.clase-detalle-html ::v-deep h1,
.ck-content h1 {
  font-size: 1.6rem !important;
}

.clase-detalle-html ::v-deep h2,
.ck-content h2 {
  font-size: 1.35rem !important;
}

.clase-detalle-html ::v-deep h3,
.ck-content h3 {
  font-size: 1.2rem !important;
}

.clase-detalle-html ::v-deep p,
.ck-content p {
  margin: 0 0 1em !important;
  color: #1f2937 !important;
}

.clase-detalle-html ::v-deep ul,
.ck-content ul,
.clase-detalle-html ::v-deep ol,
.ck-content ol {
  margin: 0 0 1em !important;
  padding-left: 1.35em !important;
}

.clase-detalle-html ::v-deep li,
.ck-content li {
  margin-bottom: 0.35rem !important;
}

.clase-detalle-html ::v-deep a,
.ck-content a {
  color: #0b57d0 !important;
  text-decoration: underline !important;
  text-underline-offset: 2px;
  overflow-wrap: anywhere;
}

.clase-detalle-html ::v-deep blockquote,
.ck-content blockquote {
  margin: 1em 0 !important;
  padding: 10px 12px !important;
  border-left: 4px solid #cbd5e1 !important;
  background: #f8fafc !important;
  color: #334155 !important;
}

.clase-detalle-html ::v-deep img,
.ck-content img {
  max-width: 100% !important;
  height: auto !important;
  border-radius: 6px;
  margin: 0.75em auto !important;
  display: block;
}

/* Ajustes específicos para que los estilos no rompan la UI de CKEditor */
.ck-editor__editable_inline {
  padding: 0 20px !important;
}

.ck.ck-editor__main > .ck-editor__editable {
  background: #fcfdff !important;
}

.clase-detalle-html ::v-deep pre {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  background: #111827;
  color: #f9fafb;
  border-radius: 6px;
  padding: 12px;
  margin: 1em 0;
  font-size: 0.9rem;
  line-height: 1.55;
}

.clase-detalle-html ::v-deep code {
  background: #f3f4f6;
  border-radius: 4px;
  padding: 1px 4px;
  color: #1f2937;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono",
    monospace;
  font-size: 0.9em;
}

.clase-detalle-html ::v-deep pre code {
  background: transparent;
  padding: 0;
  color: inherit;
}

.clase-detalle-html ::v-deep table {
  width: 100%;
  display: block;
  overflow-x: auto;
  border-collapse: collapse;
  margin: 1em 0;
  background: #fff;
}

.clase-detalle-html ::v-deep th,
.clase-detalle-html ::v-deep td {
  border: 1px solid #e5e7eb;
  padding: 8px 10px;
  vertical-align: top;
}

.clase-detalle-html ::v-deep th {
  background: #f9fafb;
  color: #111827;
  font-weight: 700;
}

.clase-detalle-html ::v-deep strong {
  font-weight: 700;
}

.clase-detalle-html ::v-deep em {
  font-style: italic;
}

.clase-detalle-html ::v-deep hr {
  border: 0;
  border-top: 1px solid #e5e7eb;
  margin: 1.2em 0;
}

@media (max-width: 600px) {
  .clase-detalle-html {
    padding: 12px;
    font-size: 0.95rem;
    line-height: 1.7;
  }

  .clase-detalle-html ::v-deep h1 {
    font-size: 1.36rem;
  }

  .clase-detalle-html ::v-deep h2 {
    font-size: 1.2rem;
  }
}

/* ESTILOS GUÍA DE CONTENIDO PREMIUM */
.guia-header {
  background: linear-gradient(135deg, #1565c0, #1e88e5);
}
.guia-dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
}
.op-80 {
  opacity: 0.8;
}
.guia-content {
  background: #fbfcfd;
}
.guia-table-wrapper {
  border: 1px solid #e1e8ef;
  border-radius: 12px;
  overflow: hidden;
  background: white;
}
.guia-table {
  width: 100%;
  border-collapse: collapse;
}
.guia-table th {
  background: #f1f5f9;
  color: #475569;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  padding: 12px 16px;
  border-bottom: 2px solid #e2e8f0;
}
.guia-table td {
  padding: 20px 16px;
  border-bottom: 1px solid #f1f5f9;
}
.guia-numero-cell {
  background: #f8fafc;
  color: #1e88e5;
  font-size: 1.1rem;
}
.tema-titulo {
  color: #2c3e50;
  text-transform: uppercase;
}
.guia-subtemas-list {
  padding-left: 20px;
  color: #546e7a;
  font-size: 0.95rem;
}
.guia-subtemas-list li::marker {
  color: #1e88e5;
}
.guia-footer {
  background: #ffffff;
}
.border-top {
  border-top: 1px solid #edf2f7;
}
</style>
